import { FunctionComponent } from 'react';
import { PlayCircleFilledOutlined } from '@mui/icons-material';
import './education.scss';
import DIV from '../shared/html-tags/div';
export type Props = {
  numVideo: number;
  name: string;
  description: string;
  duration: number;
  videolink: string;
  preview: string;
};

const EducationUnit: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <div className="education-unit" aria-description={props.description}>
      <div className="videoTop">
        <div className="video-title-line">
          <div className="video-number">{props.numVideo}</div>
          <div className="video-title">{props.name}</div>
        </div>
        <p>{props.description}</p>
      </div>
      <a href={props.videolink} target="_blank" className="video-link" rel="noreferrer">
        <PlayCircleFilledOutlined />
        <DIV language="de">Video auf YouTube anschauen</DIV>
        <DIV language="en">Watch Video on YouTube</DIV>
      </a>
    </div>
  );
};

export default EducationUnit;
